<template>
    <div class="wl-container-row">
        <el-skeleton v-if="loading" class="w-full h-full" v-loading="true"/>
        <div  v-else>
            <div class="main-content">
                <div class="left-content flex-1">
                <div class="kp-common-title my-10 ">
                    {{ getUser.userType === '1' ? $t('client_home.kpTitle') : $t('client_home.clientTitle') }}
                </div>
            
                <div class="pbc-container" v-if="menuCodeList.includes('client001')">
                    <card-title :title="$t('client_home.pbcItem')" @toDashboard="toItemDashboard('pbc','client001')" :clickable="menuCodeList.includes('client001')">
                        <template slot="select" v-if="menuCodeList.includes('client001')">
                            <el-select v-model="pbcFilter" class="home-select" @change="queryHomePageAllPbcNum('search')">
                                <el-option
                                v-for="item in pbcOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </template>
                    </card-title>
                   
                    
                    <div class="flex mt-15">
                        <template v-for="item in pbcItems" >
                            <card-item :itemName="item.itemName" :iconName="item.iconName" :itemNumber="item.itemNumber" class="pbc-item" href="pbc" :status="item.status" @toFilterList="toFilterList('pbc',item.status,'client001')" :hasAuth="menuCodeList.includes('client001')"></card-item>
                        </template>
                    </div>
                    
                </div>
                <div class="flex">
                    <div class="confirmation-container flex-1" :class="{'mr-20':menuCodeList.includes('client003')}" v-if="menuCodeList.includes('client006')">
                        <card-title :title="$t('client_home.confirmationItem')" @toDashboard="toItemDashboard('confirmation','client006')" :clickable="menuCodeList.includes('client006')"></card-title>
                        <div class="flex" :class="[menuCodeList.includes('client003')?'flex-col':'flex-row']">
                        <template v-for="item in confirmationItems" >
                            <card-item :itemName="item.itemName" :iconName="item.iconName" :itemNumber="item.itemNumber" :numMiddle="false" class="confirmation-item" :class="{'flex-1':!menuCodeList.includes('client003'),'mr-15':!menuCodeList.includes('client003')}" :status="item.status" @toFilterList="toFilterList('confirmation',item.status,'client006')" :hasAuth="menuCodeList.includes('client006')"></card-item>
                        </template>
                    </div>
                </div>
                    
                    <div class="mattersLog-container" v-if="menuCodeList.includes('client003')">
                        <card-title :title="$t('client_home.mattersLogItem')" @toDashboard="toItemDashboard('matterLogs','client003')" :clickable="menuCodeList.includes('client003')">
                            <template slot="select">
                            <el-select v-model="mattersLogFilter" class="home-select" @change="queryMatterInfo('search')" v-if="menuCodeList.includes('client003')">
                                <el-option
                                v-for="item in pbcOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </template>
                        </card-title>
                        <div class="flex justify-center border-normal mt-10">
                        <template v-for="item in mattersLogItems" >
                            <card-item :itemName="item.itemName" :iconName="item.iconName" :itemNumber="item.itemNumber" class="mattersLog-item" :class="{'mattersLog-item-single':!menuCodeList.includes('client006')}" href="confirmation" :status="item.status" @toFilterList="toFilterList('matterLogs',item.status,'client003')" :hasAuth="menuCodeList.includes('client003')" :numMiddle="menuCodeList.includes('client006')"></card-item>
                        </template>
                    </div>
                    </div>
                </div>
                <div class="statutory-container" v-if="menuCodeList.includes('client002')">
                    <card-title :title="$t('client_home.accountsOverview')" @toDashboard="toItemDashboard('accounts','client002')" :clickable="menuCodeList.includes('client002')"></card-title>
                    <hr class="line-split">
                    <executive-dashboard></executive-dashboard>
                </div>
            </div>
            <div class="right-content-container">
                <div class="kp-common-title my-10 flex justify-between">
                    {{ $t('client_home.workspace') }}
                    <div :class="updateGuide && updateGuideStep === 2 && false ? 'updateGuideBtn' : ''">
                        <el-button class="wl-green svg-btn" @click="showClientDownload">
                            <img src="@/assets/img/icon-statisticaldata.svg" width="100%" class="btn-icon" />
                            <!-- <i class="btn-icon el-icon-download" style="color: white;"></i> -->
                            {{ $t('site007') }}
                        </el-button>
                        <i v-if="getUser.userType === '1' && isShowWaring" class="el-icon-warning waring-icon"></i>
                        
                    </div>
                </div>
                <div class="updateGuide" v-if="updateGuide&&(updateGuideStep === 1 || clientAdminNoticeFlag)"></div>
                <div class="right-content">
                    <div class="wl-client-container kpmg">
                    <template v-for="(item, index) in menu">
                        <!-- 其他客户主界面的子目录受general配置控制-->
                        <div
                            v-if="getShowMenuCodeList.indexOf(item.menuCode) !== -1"
                            :key="item.key"
                            class="border-normal"
                            :class="getBgClassName(item.menuCode)"
                            @click="goDetail(item)"
                        >
                            <!--更新指导 start-->
                            <div class="updateGuideTip" v-if="updateGuide && updateGuideStep === 1 && item.menuCode === 'client004'">
                                <div class="margin-bottom-10">{{ $t('KPMGExecutiveEducation') }}</div>
                                <el-button @click="gotItClick({homeNoticeReadFlag: 1})" class="guide-btn">{{ $t('gotIt') }}</el-button>
                            </div>
                            <!--更新指导 ene-->

                            <!--更新指导-fapiao start-->
                            <div class="updateGuideTip" v-if="updateGuide && clientAdminNoticeFlag&& item.menuCode === 'client008'">
                                <div class="margin-bottom-10">{{ $t('newFapiaoTip') }}</div>
                                <el-button @click="gotItClick({clientAdminNoticeFlag: 1})" class="guide-btn">{{ $t('gotIt') }}</el-button>
                            </div>
                            <!--更新指导 ene-->
                            <div v-if="item.menuCode === 'client006'&&false" :class="['icon-new', iconNew]" />
                            <div v-if="item.menuCode === 'client005'&&false" :class="['icon-new', iconNew]" />
                            <div v-if="item.menuCode === 'client008'" :class="['icon-new', iconNew]" />
                            <div v-if="item.menuCode === 'client004'&&false" :class="['icon-new', iconNewSAS]" />
                            <div class="menu_item_info">
                                <img v-if="item.menuCode === 'client001'" src="@/assets/img/client-icon01.png" />
                                <img v-if="item.menuCode === 'client005'" src="@/assets/img/client-icon02.png" />
                                <img v-if="item.menuCode === 'client002'" src="@/assets/img/client-icon03.png" />
                                <img v-if="item.menuCode === 'client003'" src="@/assets/img/client-icon04.png" />
                                <img v-if="item.menuCode === 'client004'" src="@/assets/img/client-icon05.png" />
                                <img v-if="item.menuCode === 'client006'" src="@/assets/img/client-icon06.png" />
                                <img v-if="item.menuCode === 'client007'" src="@/assets/img/client-icon07.png" />
                                <img v-if="item.menuCode === 'client008'" src="@/assets/img/client-icon08.png" />
                                <div
                                    :style="'color: ' + getFontColor(item.menuCode)"
                                    :class="['menu', $i18n.locale === 'en' ? 'en-fontSize' : '']"
                                >
                                    {{ $t(item.menuCode) }}
                                </div>
                            </div>
                            <div :class="getCoverBgClassName(item.menuCode)">
                                <div
                                    :class="[
                                        'vertical',
                                        $i18n.locale === 'en' ? 'en-cover-fontSize' : '',
                                        `cover-${$i18n.locale}-${item.menuCode}`
                                    ]"
                                >
                                    {{ $t(item.menuCode + '_des') }}
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <hr class="line-split">
                <right-baseItem :item-name="$t('client_home.clientContact')" type="contact" icon-name="kpContact"></right-baseItem>
                <right-baseItem :item-name="$t('client_home.recommendTitle')" type="speed" icon-name="kpSpeed"></right-baseItem>
                </div>
            </div>
            </div>
            
        </div>

        <!--客户下载文件跟踪-->
        <el-drawer :visible.sync="clientDownloadVis" direction="rtl" size="80%" :before-close="handleClientDownloadClose">
            <div class="wl-info" slot="title">
                <div class="wl-info-title">{{ $t('site007') }}</div>
                <div v-if="getUser.userType === '1'" class="column-btn" @click="setClick">
                    <img src="@/assets/img/icon-setting1.svg" width="100%" class="table-setting-icon" />
                    <span>{{ $t('alter_setting') }}</span>
                </div>
            </div>
            <el-row class="search-row">
                <div class="el-col-12 el-row--flex">
                    <span style="line-height: 30px; margin-right: 5px">{{ $t('downloaded_date') }}: </span>
                    <el-date-picker
                        class="wl-item wl-date-item2 input-with-select margin"
                        v-model="datePickerVal"
                        :picker-options="pickerOptions"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="~"
                        :start-placeholder="$t('begin_date')"
                        :end-placeholder="$t('end_date')"
                        @blur="searchBtnClick"
                        :popper-class="[this.$i18n.locale === 'en' ? 'date-search-popper' : '']"
                    >
                    </el-date-picker>
                    <el-button icon="el-icon-search" @click="searchBtnClick" class="wl-green">{{ $t('btn_search2') }} </el-button>
                    <el-button @click="clearAll" class="cancel-btn">{{ $t('COMMON_CLEAR_BTN') }} </el-button>
                </div>
                <div class="el-col-12" v-if="getUser.userType === '1'">
                    <el-button @click="exportBtnClick" class="wl-green right">
                        <img src="@/assets/img/icon-export.svg" width="100%" class="btn-icon" alt="" />
                        {{ $t('export_downloaded_files_list') }}
                    </el-button>
                </div>
            </el-row>
            <div class="table-container-wrapper">
                <el-table height="100%" :data="tableData" v-loading="tableLoading" stripe border>
                    <el-table-column label="#" type="index" header-align="center" align="center" width="60"></el-table-column>
                    <el-table-column prop="clientUserName" header-align="center" align="left" min-width="140">
                        <template #header>
                            <!-- 表头标题 -->
                            {{ $t('client_list_user_name') }}
                            <el-popover style="display: inline-block" placement="bottom" ref="trackNumPopper1" @hide="searchBtnClick">
                                <template #reference>
                                    <div class="th-filter-down">
                                        <i class="el-icon-arrow-down"></i>
                                    </div>
                                </template>

                                <template>
                                    <div class="text-input">
                                        <el-input v-model="clientUserNameVal" />
                                        <i
                                            v-show="clientUserNameVal.length > 0"
                                            class="el-icon-circle-close clear-btn"
                                            @click.prevent="clientUserNameVal = ''"
                                        />
                                    </div>

                                    <div class="header-btn-position">
                                        <el-button class="wl-green" @click="filterClientUserName(clientUserNameVal)">{{
                                            $t('btn_search2')
                                        }}</el-button>
                                    </div>
                                </template>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column prop="email" header-align="center" align="left" min-width="140">
                        <template #header>
                            <!-- 表头标题 -->
                            {{ $t('client_list_client_email') }}
                            <el-popover style="display: inline-block" placement="bottom" ref="trackNumPopper2" @hide="searchBtnClick">
                                <template #reference>
                                    <div class="th-filter-down">
                                        <i class="el-icon-arrow-down"></i>
                                    </div>
                                </template>

                                <template>
                                    <div class="text-input">
                                        <el-input v-model="emailVal" />
                                        <i
                                            v-show="emailVal.length > 0"
                                            class="el-icon-circle-close clear-btn"
                                            @click.prevent="emailVal = ''"
                                        />
                                    </div>

                                    <div class="header-btn-position">
                                        <el-button class="wl-green" @click="filterEmailVal(emailVal)">{{ $t('btn_search2') }}</el-button>
                                    </div>
                                </template>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column label="PBC" prop="PBC" header-align="center">
                        <el-table-column :label="$t('businesshome_right_row1_title_pcs')" prop="pbcPcs" header-align="center" align="right">
                            <template #header>
                                <div class="th">
                                    <!-- 表头标题 -->
                                    <div class="th-label">{{ $t('businesshome_right_row1_title_pcs') }}</div>
                                    <!-- 排序上下箭头 -->
                                    <div class="th-sort" @click="switchSort('pbcPcs')">
                                        <i
                                            class="el-icon-caret-top th-sort-up"
                                            :class="[sort.pbcPcs === 'asc' ? 'th-sort-active' : '']"
                                        ></i>
                                        <i
                                            class="el-icon-caret-bottom th-sort-down"
                                            :class="[sort.pbcPcs === 'desc' ? 'th-sort-active' : '']"
                                        ></i>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('size')" prop="pbcSize" header-align="center" align="right">
                            <template #header>
                                <div class="th">
                                    <!-- 表头标题 -->
                                    <div class="th-label">{{ $t('size') }}</div>
                                    <!-- 排序上下箭头 -->
                                    <div class="th-sort" @click="switchSort('pbcSize')">
                                        <i
                                            class="el-icon-caret-top th-sort-up"
                                            :class="[sort.pbcSize === 'asc' ? 'th-sort-active' : '']"
                                        ></i>
                                        <i
                                            class="el-icon-caret-bottom th-sort-down"
                                            :class="[sort.pbcSize === 'desc' ? 'th-sort-active' : '']"
                                        ></i>
                                    </div>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <span>{{ scope.row.pbcSize | fileSize }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="$t('config_joint_title')" prop="jointWorking" header-align="center" align="center">
                        <el-table-column
                            :label="$t('businesshome_right_row1_title_pcs')"
                            prop="jointWorkingPcs"
                            header-align="center"
                            align="right"
                        >
                            <template #header>
                                <div class="th">
                                    <!-- 表头标题 -->
                                    <div class="th-label">{{ $t('businesshome_right_row1_title_pcs') }}</div>
                                    <!-- 排序上下箭头 -->
                                    <div class="th-sort" @click="switchSort('jointWorkingPcs')">
                                        <i
                                            class="el-icon-caret-top th-sort-up"
                                            :class="[sort.jointWorkingPcs === 'asc' ? 'th-sort-active' : '']"
                                        ></i>
                                        <i
                                            class="el-icon-caret-bottom th-sort-down"
                                            :class="[sort.jointWorkingPcs === 'desc' ? 'th-sort-active' : '']"
                                        ></i>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('size')" prop="jointWorkingSize" header-align="center" align="right">
                            <template #header>
                                <div class="th">
                                    <!-- 表头标题 -->
                                    <div class="th-label">{{ $t('size') }}</div>
                                    <!-- 排序上下箭头 -->
                                    <div class="th-sort" @click="switchSort('jointWorkingSize')">
                                        <i
                                            class="el-icon-caret-top th-sort-up"
                                            :class="[sort.jointWorkingSize === 'asc' ? 'th-sort-active' : '']"
                                        ></i>
                                        <i
                                            class="el-icon-caret-bottom th-sort-down"
                                            :class="[sort.jointWorkingSize === 'desc' ? 'th-sort-active' : '']"
                                        ></i>
                                    </div>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <span>{{ scope.row.jointWorkingSize | fileSize }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="$t('client002')" prop="statutory" header-align="center">
                        <el-table-column
                            :label="$t('businesshome_right_row1_title_pcs')"
                            prop="statutoryPcs"
                            header-align="center"
                            align="right"
                        >
                            <template #header>
                                <div class="th">
                                    <!-- 表头标题 -->
                                    <div class="th-label">{{ $t('businesshome_right_row1_title_pcs') }}</div>
                                    <!-- 排序上下箭头 -->
                                    <div class="th-sort" @click="switchSort('statutoryPcs')">
                                        <i
                                            class="el-icon-caret-top th-sort-up"
                                            :class="[sort.statutoryPcs === 'asc' ? 'th-sort-active' : '']"
                                        ></i>
                                        <i
                                            class="el-icon-caret-bottom th-sort-down"
                                            :class="[sort.statutoryPcs === 'desc' ? 'th-sort-active' : '']"
                                        ></i>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('size')" prop="statutorySize" header-align="center" align="right">
                            <template #header>
                                <div class="th">
                                    <!-- 表头标题 -->
                                    <div class="th-label">{{ $t('size') }}</div>
                                    <!-- 排序上下箭头 -->
                                    <div class="th-sort" @click="switchSort('statutorySize')">
                                        <i
                                            class="el-icon-caret-top th-sort-up"
                                            :class="[sort.statutorySize === 'asc' ? 'th-sort-active' : '']"
                                        ></i>
                                        <i
                                            class="el-icon-caret-bottom th-sort-down"
                                            :class="[sort.statutorySize === 'desc' ? 'th-sort-active' : '']"
                                        ></i>
                                    </div>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <span>{{ scope.row.statutorySize | fileSize }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="$t('client003')" prop="matterLog" header-align="center">
                        <el-table-column
                            :label="$t('businesshome_right_row1_title_pcs')"
                            prop="matterLogPcs"
                            header-align="center"
                            align="right"
                        >
                            <template #header>
                                <div class="th">
                                    <!-- 表头标题 -->
                                    <div class="th-label">{{ $t('businesshome_right_row1_title_pcs') }}</div>
                                    <!-- 排序上下箭头 -->
                                    <div class="th-sort" @click="switchSort('matterLogPcs')">
                                        <i
                                            class="el-icon-caret-top th-sort-up"
                                            :class="[sort.matterLogPcs === 'asc' ? 'th-sort-active' : '']"
                                        ></i>
                                        <i
                                            class="el-icon-caret-bottom th-sort-down"
                                            :class="[sort.matterLogPcs === 'desc' ? 'th-sort-active' : '']"
                                        ></i>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('size')" prop="matterLogSize" header-align="center" align="right">
                            <template #header>
                                <div class="th">
                                    <!-- 表头标题 -->
                                    <div class="th-label">{{ $t('size') }}</div>
                                    <!-- 排序上下箭头 -->
                                    <div class="th-sort" @click="switchSort('matterLogSize')">
                                        <i
                                            class="el-icon-caret-top th-sort-up"
                                            :class="[sort.matterLogSize === 'asc' ? 'th-sort-active' : '']"
                                        ></i>
                                        <i
                                            class="el-icon-caret-bottom th-sort-down"
                                            :class="[sort.matterLogSize === 'desc' ? 'th-sort-active' : '']"
                                        ></i>
                                    </div>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <span>{{ scope.row.matterLogSize | fileSize }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="$t('config_confirmation')" prop="confirmation" header-align="center">
                        <el-table-column
                            :label="$t('businesshome_right_row1_title_pcs')"
                            prop="confirmationPcs"
                            header-align="center"
                            align="right"
                        >
                            <template #header>
                                <div class="th">
                                    <!-- 表头标题 -->
                                    <div class="th-label">{{ $t('businesshome_right_row1_title_pcs') }}</div>
                                    <!-- 排序上下箭头 -->
                                    <div class="th-sort" @click="switchSort('confirmationPcs')">
                                        <i
                                            class="el-icon-caret-top th-sort-up"
                                            :class="[sort.confirmationPcs === 'asc' ? 'th-sort-active' : '']"
                                        ></i>
                                        <i
                                            class="el-icon-caret-bottom th-sort-down"
                                            :class="[sort.confirmationPcs === 'desc' ? 'th-sort-active' : '']"
                                        ></i>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('size')" prop="confirmationSize" header-align="center" align="right">
                            <template #header>
                                <div class="th">
                                    <!-- 表头标题 -->
                                    <div class="th-label">{{ $t('size') }}</div>
                                    <!-- 排序上下箭头 -->
                                    <div class="th-sort" @click="switchSort('confirmationSize')">
                                        <i
                                            class="el-icon-caret-top th-sort-up"
                                            :class="[sort.confirmationSize === 'asc' ? 'th-sort-active' : '']"
                                        ></i>
                                        <i
                                            class="el-icon-caret-bottom th-sort-down"
                                            :class="[sort.confirmationSize === 'desc' ? 'th-sort-active' : '']"
                                        ></i>
                                    </div>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <span>{{ scope.row.confirmationSize | fileSize }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="$t('total_downloaded_files')" prop="totalDownloadedFiles" header-align="center">
                        <el-table-column
                            :label="$t('businesshome_right_row1_title_pcs')"
                            prop="totalPcs"
                            header-align="center"
                            align="right"
                        >
                            <template #header>
                                <div class="th">
                                    <!-- 表头标题 -->
                                    <div class="th-label">{{ $t('businesshome_right_row1_title_pcs') }}</div>
                                    <!-- 排序上下箭头 -->
                                    <div class="th-sort" @click="switchSort('totalPcs')">
                                        <i
                                            class="el-icon-caret-top th-sort-up"
                                            :class="[sort.totalPcs === 'asc' ? 'th-sort-active' : '']"
                                        ></i>
                                        <i
                                            class="el-icon-caret-bottom th-sort-down"
                                            :class="[sort.totalPcs === 'desc' ? 'th-sort-active' : '']"
                                        ></i>
                                    </div>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <span
                                    v-if="getUser.userType === '1'"
                                    class="underline-content"
                                    :class="{ waring: scope.row.totalPcsIsOver }"
                                    @click="showDownloadFileClick(scope.row)"
                                >
                                    {{ scope.row.totalPcs }}
                                </span>
                                <span v-else style="color: #3879eb">{{ scope.row.totalPcs }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('size')" prop="totalSize" header-align="center" align="right">
                            <template #header>
                                <div class="th">
                                    <!-- 表头标题 -->
                                    <div class="th-label">{{ $t('size') }}</div>
                                    <!-- 排序上下箭头 -->
                                    <div class="th-sort" @click="switchSort('totalSize')">
                                        <i
                                            class="el-icon-caret-top th-sort-up"
                                            :class="[sort.totalSize === 'asc' ? 'th-sort-active' : '']"
                                        ></i>
                                        <i
                                            class="el-icon-caret-bottom th-sort-down"
                                            :class="[sort.totalSize === 'desc' ? 'th-sort-active' : '']"
                                        ></i>
                                    </div>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <span
                                    v-if="getUser.userType === '1'"
                                    class="underline-content"
                                    :class="{ waring: scope.row.totalSizeIsOver }"
                                    @click="showDownloadFileClick(scope.row)"
                                >
                                    {{ scope.row.totalSize | fileSize }}
                                </span>
                                <span v-else style="color: #3879eb">{{ scope.row.totalSize | fileSize }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                </el-table>
                <!-- 分页 -->
                <el-pagination
                    class="wl-pagination"
                    :current-page="pagination.pageNum"
                    :page-size="pagination.pageSize"
                    @current-change="onCurrentPageChange"
                    @size-change="onSizeChange"
                    :page-sizes="[10, 50, 100]"
                    layout="prev, pager, next, sizes, total"
                    :total="pagination.total"
                >
                </el-pagination>
            </div>
        </el-drawer>
        <!--设置预警值-->
        <el-dialog :title="$t('alter_setting')" width="400px" :visible.sync="setVisible" @close="cancelClick">
            <el-form ref="setForm" :model="setForm" label-position="top">
                <el-form-item :label="$t('client_download_title_1')" class="bottom-line">
                    <el-input-number v-model="setForm.fileNum" :min="0" /> {{ $t('UNIT_02') }}
                </el-form-item>
                <el-form-item :label="$t('client_download_title_2')" class="bottom-line">
                    <el-input-number v-model="setForm.fileSize" :min="0" /> MB
                </el-form-item>
                <el-form-item>
                    <el-switch v-model="setForm.isSendEmailAlert" class="switch-width-cls" active-color="#409EFF" inactive-color="#cccccc">
                    </el-switch>
                    {{ $t('PAGE_CLIENTUSER_EMAIL') }}
                    <div style="font-size: 12px; color: #fd349c; word-break: break-word">
                        <i class="el-icon-warning" />
                        {{ $t('alert_engagement_manager') }}
                    </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button class="wl-gray" :loading="dialogLoading" @click="cancelClick">{{ $t('btn_cancel') }}</el-button>
                <el-button class="wl-green" :loading="dialogLoading" @click="saveClick">{{ $t('btn_confirm') }}</el-button>
            </span>
        </el-dialog>
        <!--文件列表详情-->
        <el-dialog
            :title="$t('FILE_LIST_TITLE')"
            :visible.sync="showDownloadVis"
            :before-close="handleDownloadClose"
            width="70%"
            top="25vh"
        >
            <el-table :data="gridData" max-height="400" stripe v-loading="downloadFileLoading" size="mini">
                <el-table-column prop="uploadFilename" :label="$t('DOWNLOAD_FILE_NAME')" width="200" show-overflow-tooltip>
                    <!--<template slot-scope="scope">
            <div class="file-table-name-canDownload">
              <i  class="el-icon-download" @click="downloadClick(scope.row)"></i> {{ scope.row.uploadFilename }}
            </div>
          </template>-->
                </el-table-column>
                <el-table-column prop="size" :label="$t('DOWNLOAD_SIZE')">
                    <template slot-scope="scope">{{ scope.row.size | fileSize }}</template>
                </el-table-column>
                <el-table-column prop="sourceType" :label="$t('kcc_tile')" width="200">
                    <template slot-scope="scope">{{ $t(tilesNameTrans(scope.row.sourceType)) }}</template>
                </el-table-column>
                <el-table-column prop="uploadedName" :label="$t('UPLOAD_BY')"></el-table-column>
                <el-table-column prop="uploadedDate" :label="$t('UPLOAD_TIME')">
                    <template slot-scope="scope">
                        {{ dateFormat(new Date(scope.row.uploadedDate), 'yyyy-MM-dd hh:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column prop="downloadedName" :label="$t('FILE_DOWNLOAD_BY')"></el-table-column>
                <el-table-column prop="downloadedDate" :label="$t('DOWNLOAD_TIME')">
                    <template slot-scope="scope">
                        {{ dateFormat(new Date(scope.row.downloadedDate), 'yyyy-MM-dd hh:mm:ss') }}
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
                class="wl-pagination"
                :current-page="downloadPagination.pageNum"
                :page-size="downloadPagination.pageSize"
                @current-change="downloadCurrentPageChange"
                @size-change="downloadSizeChange"
                :page-sizes="[10, 50, 100]"
                layout="prev, pager, next, sizes, total"
                :total="downloadPagination.total"
            >
            </el-pagination>
        </el-dialog>
        <admin-authorise v-if="authorisePopVisible" :onCancel="cancelAuthorisePop" :onConfirm="confirmAuthorisePop" :onNoConfirm="noAuthorisePop" :activeStep="activeStep"></admin-authorise>
        <Pwd-complexity v-if="pwdPopVisible" :onCancel="cancelPwdPop" :onConfirm="confirmPwdPop" :onNoConfirm="noPwdPop"></Pwd-complexity>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import API from '@/api'
import { dateFormat, isIE ,flat } from '@/utils'
import CardItem from './components/CardItem.vue'
import CardTitle from './components/CardTitle.vue'
import ExecutiveDashboard from './components/ExecutiveDashboard.vue'
import RightBaseItem from './components/RightBaseItem.vue'
import AdminAuthorise from './components/AdminAuthorise.vue'
import ClientTopRight from './components/ClientTopRight.vue'
import PwdComplexity from './components/PwdComplexity.vue'

export default {
    // name: "client-list",
    data() {
        return {
            dateFormat,
            isComponentMember: false,
            colorList: ['#00338d', '#fd349c', '#7213ea', '#00c0ae', '#00338d', '#3879EB','#00b8f5','#1e49e2'],
            clientDownloadVis: false,
            datePickerVal: [
                dateFormat(new Date(new Date() - 3600 * 1000 * 24 * 13), 'yyyy-MM-dd'),
                dateFormat(new Date(new Date()), 'yyyy-MM-dd')
            ],
            choiceDate: '',
            pickerOptions: {
                onPick: ({ maxDate, minDate }) => {
                    // 选中的时间
                    this.choiceDate = minDate.getTime()
                    if (maxDate) {
                        this.choiceDate = ''
                    }
                },
                disabledDate: (time) => {
                    if (this.choiceDate !== '') {
                        const oneYear = 365 * 24 * 3600 * 1000
                        const minTime = this.choiceDate - oneYear
                        const maxTime = this.choiceDate + oneYear
                        return time.getTime() > Date.now() || time.getTime() < minTime || time.getTime() > maxTime
                    } else {
                        return time.getTime() > Date.now()
                    }
                },
                shortcuts: [
                    {
                        text: this.$t('datepicker_shortcut_recently_week'),
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 13)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: this.$t('datepicker_shortcut_recently_month'),
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setMonth(start.getMonth() - 1)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: this.$t('datepicker_shortcut_recently_3month'),
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setMonth(start.getMonth() - 3)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: this.$t('datepicker_shortcut_recently_6month'),
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setMonth(start.getMonth() - 6)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: this.$t('datepicker_shortcut_recently_year'),
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setMonth(start.getMonth() - 12)
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            },
            tableData: [],
            downloadOption: [],
            emailOption: [],
            sort: {
                confirmationPcs: '',
                confirmationSize: '',
                jointWorkingPcs: '',
                jointWorkingSize: '',
                pbcPcs: '',
                pbcSize: '',
                statutoryPcs: '',
                statutorySize: '',
                totalPcs: '',
                totalSize: '',
                matterLogPcs: '',
                matterLogSize: ''
            },
            clientUserNameVal: '',
            emailVal: '',
            tableLoading: false,
            setVisible: false,
            setForm: {
                clientName: '',
                siteName: '',
                cycle: 7,
                fileNum: 100,
                fileSize: 100,
                isSendEmailAlert: true
            },
            pagination: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            dialogLoading: false,
            showDownloadVis: false,
            downloadFileLoading: false,
            gridData: [],
            downloadPagination: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            selectFileItem: {},
            isShowWaring: false,
            menu: [],
            updateGuide: false,
            updateGuideStep: 0,
            pbcFilter:'1',
            pbcAllOptions:[{
                value:'1',
                label:this.$t('COMMON_INTERIM')
            },
            {
                value:'2',
                label:this.$t('COMMON_FINAL')
            }
            ],
            pbcItems:[{
                iconName:'Duesoon',
                status:'5',
                itemName:this.$t('client_home.duePbcItem'),
                itemNumber:0
            },
            {
                iconName:'Overdued',
                status:'6',
                itemName:this.$t('client_home.overduePbcItem'),
                itemNumber:0
            },
            {
                iconName:'RevisionRequired',
                status:'3',
                itemName:this.$t('client_home.revisionPbcItem'),
                itemNumber:0
            },
            {
                iconName:'ClientUploaded',
                status:'2',
                itemName:this.$t('client_home.uploadPbcItem'),
                itemNumber:0
            }
        ],
        confirmationItems:[
            {
                iconName:'ConfirmationsStamping',
                status:'2',
                itemName:this.$t('client_home.stampingConfirmationItem'),
                itemNumber:0
            },
            {
                iconName:'ConfirmationsAddressees',
                status:'5',
                itemName:this.$t('client_home.addressConfirmationItem'),
                itemNumber:0
            },
        ],
        mattersLogItems:[{
            iconName:'MattersSolution',
            status:'2,1',
            itemName:this.$t('client_home.solutionMattersLogItem'),
            itemNumber:0
        }],
        mattersLogFilter: '1',
        loading: true,
        authorisePopVisible: false,
        clientAdminNoticeFlag: false,
        activeStep:-1,
        pwdPopVisible: false,
        }
    },
    components: { CardItem,CardTitle,ExecutiveDashboard,RightBaseItem,AdminAuthorise,ClientTopRight,PwdComplexity},
    computed: {
        ...mapGetters('common', {
            getCurrentMenu: 'getCurrentMenu',
            getSite: 'getSite',
            getUser: 'getUser',
            getShowMenuCodeList: 'getShowMenuCodeList',
            getEntityIds: 'getEntityIds',
        }),
        iconNew() {
            return this.$i18n.locale === 'zh' ? 'icon-new-zh' : 'icon-new-en'
        },
        iconNewSAS() {
            return this.$i18n.locale === 'zh' ? 'icon-new-sas-zh' : 'icon-new-sas-en'
        },
        menuCodeList(){
            return this.getShowMenuCodeList
        },
        pbcOptions(){
            return this.getSite.hasInterim?this.pbcAllOptions:[this.pbcAllOptions[1]]
        },
        isClient(){
            return this.getUser.userType === '2'
        }
        // menu() {
        //   // currentMenu 是全部的，showMenuList 是显示的，后者要过滤前者
        //   let menu = []
        //   if (this.getCurrentMenu.find(v => v.href === 'client')) {
        //       let temp = this.getCurrentMenu.find(v => v.href === 'client').childMenuList;
        //       // 如果是kp组成部分人员，只显示joint working页面
        //       if (this.getUser.userType === '1' && this.isComponentMember) {
        //         menu = temp.filter(i => i.menuCode === 'client005')
        //       } else {
        //         menu = temp
        //       }
        //   }
        //   return menu
        // }
    },
    methods: {
        checkAccount() {
            API.common.checkAccount({ param: this.getUser.userAccount}).then((res) => {
                if (res.code === '1') {
                    const { oldPwdFlag,showPasswordUpdatePop } = res.data
                    this.pwdPopVisible = oldPwdFlag&&showPasswordUpdatePop;
                }
            })
        },
        async queryShowClientAdminPop(){
            const { siteId,siteUsageStatus } = this.$route.query
            if(!siteId) {
                this.authorisePopVisible = false
                return;
            }

            if(siteUsageStatus === 'Closed'){
                this.authorisePopVisible = false
                return;
            }

            const { code, data } = await API.common.queryShowClientAdminPop({
                siteId:this.getSite.siteId,
                userId: this.getUser.userId
            })
            if(code === '1'&&data){
                this.authorisePopVisible = data!=='COMPLETED_OR_NOT_APPLICABLE';
                if(this.authorisePopVisible){
                    this.activeStep = data ==='STEP1'?-1:1
                }
            }
        },
        cancelAuthorisePop(){
            this.authorisePopVisible = false;
        },
        confirmAuthorisePop(){
            this.$router.push('/clientUsers');
        },
        async noAuthorisePop(){
            await API.common.setShowClientAdminPop({
                siteId:this.getSite.siteId,
                showClientAdminPop:false,
                userId: this.getUser.userId
            })
            this.cancelAuthorisePop()
        },
        cancelPwdPop(){
            this.pwdPopVisible = false;
        },
        confirmPwdPop(){
            //跳转至修改密码页面
            this.$router.push('/changePassword')
        },
        async noPwdPop(){
            await API.common.updatePwdPop({
                showPasswordUpdatePop:false,
                clientId: this.getUser.userId
            })
            this.cancelPwdPop()
        },

        async getUserEntity(menuId){
            let entityId = []
            const { code, data } = await API.common.queryUserEntity({
                siteId:this.getSite.siteId,
                menuId,
                userType: this.getUser.userType
            })
            if(code == '1'){
                //disabled为0表示为entity选中
                entityId = flat([data]).filter(item=>!item.disabled).map(item=>item.id) 
            }
            return entityId;
        },
        updateSiteInfo(){
            API.businessHome.querySite({ siteIds: this.getSite.siteId }).then((res) => {
                if (res.code == '1') {
                    this.$store.commit('common/setSite', res.data.records[0])
                }
            })
        },
        //查询PBC数据
        async getPbcNumbers() {
            try {
                const params = {
                    auditType:this.pbcFilter,
                    siteId: this.getSite.siteId,
                    lang:this.$i18n.locale,
                    entityId: this.getEntityIds,
                };
                const { data, code } = await API.pbc.getPieData(params)
                if (code == '1') {
                    const {due,overdue,revisionRequired,uploaded} = data;
                    this.pbcItems[0].itemNumber = due;
                    this.pbcItems[1].itemNumber = overdue;
                    this.pbcItems[2].itemNumber = revisionRequired;
                    this.pbcItems[3].itemNumber = uploaded;
                    
                } else {
                    this.$message.error(this.$t(code))
                }
            } catch (e) {
            } 
        },
        hasPbcNumber(data) {
            const {due,overdue,revisionRequired,uploaded} = data;
            return !!(due || overdue || revisionRequired || uploaded)
        },
        setPbcNumber(data){
            this.pbcItems[0].itemNumber = data.due;
            this.pbcItems[1].itemNumber = data.overdue;
            this.pbcItems[2].itemNumber = data.revisionRequired;
            this.pbcItems[3].itemNumber = data.uploaded;
        },
        //查询全量PBC数据
        async queryHomePageAllPbcNum(type) {
            const entityId =  await this.getUserEntity('14')
            if (entityId.length < 1) return
            try {
                const params = {
                    siteId: this.getSite.siteId,
                    lang:this.$i18n.locale,
                    entityId
                };
                const { data, code } = await API.pbc.queryHomePageAllPbcNum(params);
                if (code == '1') {
                    if(!type){
                        const hasInterim = this.hasPbcNumber(data.interim);
                        const hasFinal = this.hasPbcNumber(data.final);
                        if(hasFinal){
                            this.setPbcNumber(data.final);
                            this.pbcFilter = '2'
                        }else if(hasInterim&&this.getSite.hasInterim){
                            this.setPbcNumber(data.interim);
                            this.pbcFilter = '1'
                        }
                    }else{
                        if(this.pbcFilter === '1'){
                            this.setPbcNumber(data.interim);
                        }else{
                            this.setPbcNumber(data.final);
                        }
                    } 
                } else {
                    this.$message.error(this.$t(code))
                }
            } catch (e) {
            } 
        },
        toItemDashboard(href,code){
            const queryParams = {
                openDashboard:1
            }
            if(code === 'client001'){
                queryParams.active = this.pbcFilter
            }else if(code === 'client003'){
                queryParams.active = this.mattersLogFilter
            }
    
            this.$router.push({ path: '/' + href,query:queryParams})
        },
        toFilterList(href,status,code){
            if(!this.menuCodeList.includes(code))return;
            const queryParams = {
                homeFilterStatus:status
            }
            if(code === 'client001'){
                queryParams.active = this.pbcFilter
            }else if(code === 'client003'){
                queryParams.active = this.mattersLogFilter
            }
            
            this.$router.push({ path: '/' + href,query:queryParams})
        },
        //查询confirmation数据
        getConfirmationNumber() {
            let params = {
                siteId: this.getSite.siteId,
                confirmationTypeKcc:[],
                entityId:[],
                userSetOverdueDays:5
            }
            API.confirmation.queryHomePageConfirmation(params).then((res) => {
                if (res.code === '1') {
                    const {confirmationsReceivedAndProcessedByAddresseesNum,pendingForClientAuthorisationNum} = res.data;
                    this.confirmationItems[0].itemNumber=pendingForClientAuthorisationNum;
                    this.confirmationItems[1].itemNumber=confirmationsReceivedAndProcessedByAddresseesNum;
                   
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })  
        },
        //查询MattersLog数量
        async queryMatterInfo(type) {
            const entityIds =  await this.getUserEntity('16')
            if(entityIds.length<1) return
            const res = await API.matterLogs.queryHomePageMatterInfo({
                auditType: this.mattersLogFilter,
                siteId: this.getSite.siteId,
                statusList:[2,1],
                entityIds
            })
            if(res.code!=='1') return;
            const {interim,final} = res.data;

            if(!type){
                if(final){
                    this.mattersLogItems[0].itemNumber = final;
                    this.mattersLogFilter = '2'
                }else if(interim&&this.getSite.hasInterim){
                    this.mattersLogItems[0].itemNumber = interim;
                    this.mattersLogFilter = '1'
                }
            }else{
                this.mattersLogItems[0].itemNumber = this.mattersLogFilter === '1' ? interim:final
            }
            
        },
        tilesNameTrans(v) {
            const map = {
                pbc: 'client001',
                statutory: 'client002',
                matterLog: 'client003',
                insight: 'client004',
                jointWorking: 'client005',
                itu: 'client005_2',
                confirmation: 'client006',
                groupReporting: 'client007'
            }
            return map[v] ? map[v] : ''
        },
        getFontColor(code) {
            switch (code) {
                case 'client001':
                    return this.colorList[0]
                case 'client005':
                    return this.colorList[1]
                case 'client002':
                    return this.colorList[2]
                case 'client003':
                    return this.colorList[3]
                case 'client004':
                    return this.colorList[4]
                case 'client006':
                    return this.colorList[5]
                case 'client007':
                    return this.colorList[6]
                case 'client008':
                return this.colorList[7]
            }
        },
        getBgClassName(code) {
            let className = 'wl-client-item'
            switch (code) {
                case 'client001':
                    className = className + ' item1'
                    break
                case 'client005':
                    className = className + ' item2'
                    break
                case 'client002':
                    className = className + ' item3'
                    break
                case 'client003':
                    className = className + ' item4'
                    break
                case 'client004':
                    className = className + ' item5'
                    if (this.updateGuide && this.updateGuideStep === 1) {
                        className = className + ' updateGuideTitle'
                    }
                    break
                case 'client006':
                    className = className + ' item6'
                    break
                case 'client007':
                    className = className + ' item7'
                    break
                case 'client008':
                    className = className + ' item8'
                    if(this.clientAdminNoticeFlag) {
                        className = className + ' updateGuideTitle'
                    }
                    break
            }
            return className
        },
        getCoverBgClassName(code) {
            let className = 'cover'
            switch (code) {
                case 'client001':
                    className = className + ' cover1'
                    break
                case 'client005':
                    className = className + ' cover2'
                    break
                case 'client002':
                    className = className + ' cover3'
                    break
                case 'client003':
                    className = className + ' cover4'
                    break
                case 'client004':
                    className = className + ' cover5'
                    break
                case 'client006':
                    className = className + ' cover6'
                    break
                case 'client007':
                    className = className + ' cover7'
                    break
                case 'client008':
                className = className + ' cover8'
                break
            }
            return className
        },
        async getIfComponentMember() {
            let params = {
                siteId: this.getSite.siteId,
                userId: this.getUser.userId
            }
            let { code, data } = await API.exchange.queryIfKpMember(params)
            if (code === '1') {
                this.isComponentMember = data.ifKpMember
            }
        },
        checkDownloadIsOver() {
            const param = {
                siteId: this.getSite.siteId
            }
            API.clientUser.checkDownloadIsOver(param).then((res) => {
                if (res.code === '1') {
                    this.isShowWaring = res.data
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        showClientDownload() {
            if (this.updateGuide) return
            this.searchBtnClick()
            this.clientDownloadVis = true
        },
        handleClientDownloadClose() {
            this.clientDownloadVis = false
        },
        filterClientUserName(val) {
            this.$refs['trackNumPopper1'].doClose()
        },
        filterEmailVal(val) {
            this.$refs['trackNumPopper2'].doClose()
        },
        searchBtnClick() {
            this.pagination.pageNum = 1
            this.getList()
        },
        getList() {
            let param = {
                pageNum: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                sort: '',
                sortColumn: '',
                siteId: this.getSite.siteId,
                email: this.emailVal,
                clientUserName: this.clientUserNameVal,
                startDate: this.datePickerVal ? this.datePickerVal[0] : '',
                endDate: this.datePickerVal ? this.datePickerVal[1] : ''
            }
            // 查看有没有排序
            const newSort = Object.keys(this.sort).filter((k) => {
                const v = this.sort[k]
                return ['asc', 'desc'].includes(v)
            })
            if (newSort.length > 0) {
                param.sortColumn = newSort[0]
                param.sort = this.sort[newSort[0]]
            }
            this.tableLoading = true
            API.clientUser.downloadFileTracking(param).then((res) => {
                this.tableLoading = false
                if (res.code === '1') {
                    this.pagination.total = res.data.total
                    this.tableData = res.data.records
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },

        /**
         * 变更排序
         * default(none) -> desc -> asc -> default(none)
         */
        switchSort(columnName) {
            /**
             * 同时只能对一列进行排序
             * 除了当前正在操作的列，其他列的排序都清除掉
             */
            Object.keys(this.sort).forEach((k) => {
                if (k !== columnName) this.sort[k] = ''
            })
            switch (this.sort[columnName]) {
                case 'asc':
                    this.sort[columnName] = ''
                    break
                case 'desc':
                    this.sort[columnName] = 'asc'
                    break
                default:
                    this.sort[columnName] = 'desc'
                    break
            }
            this.searchBtnClick()
        },
        exportBtnClick() {
            let param = {
                sort: '',
                sortColumn: '',
                siteId: this.getSite.siteId,
                email: this.emailVal,
                clientUserName: this.clientUserNameVal,
                startDate: this.datePickerVal ? this.datePickerVal[0] : '',
                endDate: this.datePickerVal ? this.datePickerVal[1] : ''
            }
            // 查看有没有排序
            const newSort = Object.keys(this.sort).filter((k) => {
                const v = this.sort[k]
                return ['asc', 'desc'].includes(v)
            })
            if (newSort.length > 0) {
                param.sortColumn = newSort[0]
                param.sort = this.sort[newSort[0]]
            }
            API.clientUser.downloadFileTrackingExcel(param).then((res) => {
                let blob = new Blob([res])
                if (isIE()) {
                    navigator.msSaveBlob(blob, `${this.$t('site007')}.xlsx`)
                } else {
                    let url = window.URL.createObjectURL(blob)
                    let link = document.createElement('a')
                    link.style.display = 'none'
                    link.href = url
                    link.setAttribute('download', `${this.$t('site007')}.xlsx`)
                    document.body.appendChild(link)
                    link.click()
                }
            })
        },
        onSizeChange(size) {
            this.pagination.pageSize = size
            this.pagination.pageNum = 1
            this.getList()
        },
        onCurrentPageChange(current) {
            this.pagination.pageNum = current
            this.getList()
        },
        clearAll() {
            this.datePickerVal = [
                dateFormat(new Date(new Date() - 3600 * 1000 * 24 * 13), 'yyyy-MM-dd'),
                dateFormat(new Date(new Date()), 'yyyy-MM-dd')
            ]
            this.clientUserNameVal = ''
            this.emailVal = ''
            Object.keys(this.sort).forEach((k) => {
                this.sort[k] = ''
            })
            this.getList()
        },
        showDownloadFileClick(val) {
            this.showDownloadVis = true
            this.selectFileItem = val
            this.searchDownloadFileDetail()
        },
        downloadSizeChange(size) {
            this.downloadPagination.pageSize = size
            this.downloadPagination.pageNum = 1
            this.searchDownloadFileDetail()
        },
        downloadCurrentPageChange(current) {
            this.downloadPagination.pageNum = current
            this.searchDownloadFileDetail()
        },
        searchDownloadFileDetail() {
            let param = {
                pageNum: this.downloadPagination.pageNum,
                pageSize: this.downloadPagination.pageSize,
                siteId: this.getSite.siteId,
                clientId: this.selectFileItem.clientId,
                startDate: this.datePickerVal ? this.datePickerVal[0] : '',
                endDate: this.datePickerVal ? this.datePickerVal[1] : ''
            }
            this.downloadFileLoading = true
            API.clientUser.downloadFileDetail(param).then((res) => {
                this.downloadFileLoading = false
                if (res.code === '1') {
                    this.downloadPagination.total = res.data.total
                    this.gridData = res.data.records
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        handleDownloadClose() {
            this.showDownloadVis = false
        },
        downloadClick(data) {},
        cancelClick() {
            this.setVisible = false
        },
        setClick() {
            API.general.queryGeneral({ siteId: this.getSite.siteId }).then((res) => {
                if (res.code === '1') {
                    const limits = res.data.siteConfig.downloadLimit.split(',')
                    this.setForm.fileSize = limits[0]
                    this.setForm.fileNum = limits[2]
                    this.setForm.isSendEmailAlert = res.data.siteConfig.isSendEmailAlert
                    this.setForm.clientName = res.data.clientName
                    this.setForm.siteName = res.data.siteName
                    this.setVisible = true
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        saveClick() {
            this.dialogLoading = true
            let param = {
                siteId: this.getSite.siteId,
                limits: this.setForm,
                clientName: this.setForm.clientName,
                siteName: this.setForm.siteName
            }
            API.general
                .saveGeneral(param)
                .then(async (res) => {
                    this.dialogLoading = false
                    await this.getList()
                    if (res.code === '1') {
                        this.setVisible = false
                        this.$message.success(this.$t('msg_save_success'))
                    } else {
                        this.$message.success(this.$t(res.code))
                    }
                })
                .catch((e) => {
                    this.dialogLoading = false
                    this.$message.error(this.$t('SYS_USER_003'))
                })
        },
        async getMenu() {
            let param = {
                siteId: this.getSite.siteId
            }
            return API.componentUserRoles.queryClientMenu(param).then((res) => {
                if (res.code === '1') {
                    this.menu = res.data.filter((v) => {
                        if (this.getUser.userType == 2 && v.menuCode == 'client007') return false
                        return true
                    })
                } else {
                    this.$message.success(this.$t(res.code))
                }
            })
        },
        goDetail(item) {
             
            if (this.updateGuide) return
            this.$router.push({ path: '/' + item.href })
        },
        getBehavior() {
            API.common.queryBehavior().then((res) => {
                if (res.code === '1') {
                    this.clientAdminNoticeFlag = res.data.clientAdminNoticeFlag === 0  && this.getShowMenuCodeList.includes('client008')
                    this.updateGuide = res.data.homeNoticeReadFlag === 0 || this.clientAdminNoticeFlag
                    if (this.updateGuide&&!this.clientAdminNoticeFlag) {
                        this.menu.map((v) => v.menuCode).includes('client004') && this.getShowMenuCodeList.includes('client004')
                            ? (this.updateGuideStep = 1)
                            : (this.updateGuideStep = 0)
                    }
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        gotItClick(param) {
            API.common.updateBehavior(param).then((res) => {
                if (res.code === '1') {
                    this.updateGuide = false
                    this.updateGuideStep = 0
                    this.clientAdminNoticeFlag = res.data.clientAdminNoticeFlag === 0
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        }
    },
    async mounted() {
        try {
            await this.updateSiteInfo();
            //pbcFilter和mattersLogFilter初始化赋值
            this.pbcFilter = this.pbcOptions[0].value
            this.mattersLogFilter = this.pbcOptions[0].value
            await this.getIfComponentMember()
            await this.checkDownloadIsOver()
            await this.getMenu()
        
            //查询数量
            if(this.menuCodeList.includes('client001')){
                this.queryHomePageAllPbcNum()
            }

            if(this.menuCodeList.includes('client006')){
                this.getConfirmationNumber();
            }
            if(this.menuCodeList.includes('client003')){
                this.queryMatterInfo();
            } 

            this.queryShowClientAdminPop();
            this.loading = false
            if(this.isClient){
                this.checkAccount()
            }

        } catch (e) {
            this.loading = false
        }
    },
    watch: {
        getShowMenuCodeList() {
            this.getBehavior()
        }
    }
}
</script>
<style scoped>
.wl-container-row {
    width: 100%;
}

.site-common-title {
    color: #00338d;
    font-size: 24px;
    height: 40px;
    line-height: 40px;
    font-weight: bolder;
}
.main-content {
    display: flex;
    justify-content: space-between;
}
.left-content{
    width: 0;
    min-width: 0;
}
.item-empty {
    background: #f6f6f6 !important;
    color: #333333;
}

.pbc-container {
    background: #ffffff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 1px -2px 12px rgba(215, 215, 215, 0.5)
}
.confirmation-item{
    height: 90px;
    margin:10px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding:10px 8% 10px 25px;
    cursor: pointer; 
}
.mattersLog-item{
    height: 180px;
    margin:10px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    padding:10px;
    cursor: pointer;
    border:0; 
}
.mattersLog-item-single{
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    height: auto;
    padding: 10px;
}
.pbc-item{
    width: calc((100% - 60px)/4);
    height: 180px;
    margin-right:20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    padding:10px 0;
    cursor: pointer;
}
.pbc-item:nth-child(4n){
    margin-right: 0;
}
.confirmation-container,.mattersLog-container,.statutory-container{
    margin-top: 10px;
    background: #ffffff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 1px -2px 12px rgba(215, 215, 215, 0.5);
}
.confirmation-container + .mattersLog-container{
    width: 30%;
    /* min-width: 320PX; */
    min-width: 320PX;
    flex:0;
}
.mattersLog-container{
    flex:1;
}
.statutory-container{
    height:495px;
}

.line-split{
    margin: 10px -10px;
    border: none;
    background: #e5e5e5;
    height: 1px;
}

.right-content-container {
    width: 40%;
    min-width: 400px;
    margin-left: 15px;
    
}
.right-content{
    background: #ffffff;
    padding: 20px;
    box-shadow: 1px -2px 12px rgba(215, 215, 215, 0.5);
    border-radius: 10px;
}
.title {
    font-size: 18px;
    color: #333333;
    font-weight: bolder;
    height: 36px;
    line-height: 36px;
}
.home-select{
    width: 100px;
    margin-right: 10px;
}
.home-select::v-deep .el-input__inner{
    background: #f3f6ff;
    color: #1e49e2;
    border:0;
    font-size: 14px;
    border-radius: 10px;
}
.home-select::v-deep .el-select__caret{
    color: #1e49e2 !important;
    font-weight: bold;
}
.wl-client-container {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
}
.wl-client-item {
    position: relative;
    background: #fff;
    width: calc((100% - 20px) / 2);
    margin-right: 20px;
    margin-bottom: 20px;
    text-align: center;
    cursor: pointer;
    font-size: 40px;
    line-height: 48px;
    border-radius: 10px;
    height: 0;
    padding-bottom: 200px;
    position: relative;
}
.icon-new {
    display: inline-block;
    position: absolute;
    height: 60px;
    z-index: 6;
}
.icon-new-en {
    background: url('~@/assets/img/client_new_en.png') no-repeat;
    background-size: contain;
    width: 64px;
    left: -10px;
    top: -25px;
}
.icon-new-zh {
    background: url('~@/assets/img/client_new_cn.png') no-repeat;
    background-size: contain;
    width: 103px;
    left: -15px;
    top: -15px;
}
.icon-new-sas-en {
    background: url('~@/assets/img/client_upgraded_en.png') no-repeat;
    background-size: contain;
    width: 106px;
    left: -15px;
    top: -20px;
}
.icon-new-sas-zh {
    background: url('~@/assets/img/client_upgraded_cn.png')  no-repeat;
    background-size: contain;
    width: 103px;
    left: -15px;
    top: -15px;
}
.wl-client-item:nth-child(2n) {
    margin-right: 0;
}
.wl-client-item::before {
    content: '';
    display: block;
    height: 30px;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
}



.wl-client-item.item5 .updateGuideTip {
    top: -190px;
}

.wl-client-item.item8 .updateGuideTip {
    top: -150px;
}


.menu_item_info {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    position: absolute;
    width: 80%;
    top:50%;
    left: 50%;
    transform: translate(-50%,-50%);

}
.menu_item_info img {
    height: 64px;
}

.wl-client-item .menu {
    width: 100%;
    margin-top:20px;
    line-height: 30px;
    font-size: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.wl-hidden {
    visibility: hidden;
}
.cover {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    position: absolute;
    opacity: 0;
}
.cover1 {
    background: url('~@/assets/img/bg-ClientHover-01.png') center center/100% 100% no-repeat;
}
.cover2 {
    background: url('~@/assets/img/bg-ClientHover-02.png') center center/100% 100% no-repeat;
}
.cover3 {
    background: url('~@/assets/img/bg-ClientHover-07.png') center center/100% 100% no-repeat;
}
.cover4 {
    background: url('~@/assets/img/bg-ClientHover-04.png') center center/100% 100% no-repeat;
}
.cover5 {
    background: url('~@/assets/img/bg-ClientHover-01.png') center center/100% 100% no-repeat;
}
.cover6 {
    background: url('~@/assets/img/bg-ClientHover-05.png') center center/100% 100% no-repeat;
}
.cover7 {
    background: url('~@/assets/img/bg-ClientHover-06.png') center center/100% 100% no-repeat;
}
.cover8 {
    background: url('~@/assets/img/bg-ClientHover-05.png') center center/100% 100% no-repeat;
}

.cover:hover {
    transition: all 1s;
    height: 100%;
    opacity: 1;
    border-radius: 10px;
}
.vertical {
    height: 100%;
    font-size: 30px;
    color: #ffffff;
    padding: 11px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.cover .en-cover-fontSize {
    font-size: 24px;
    line-height: 1.5;
}

.wl-client-item .en-fontSize {
    font-size: 30px;
    line-height: 30px;
    font-family: 'Open Sans Condensed',Arial,Helvetica,sans-serif;
}
.title-main {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding-bottom: 10px;
    border-bottom: 1px solid #e5e5e5;
    height: 54PX;
}
.waring-icon {
    color: #f2b000;
    position: absolute;
    right: -6px;
    top: -6px;
    font-size: 14px;
}
::v-deep .el-drawer__header {
    margin-bottom: 0;
    border-bottom: 1px solid #e3e4e6;
    padding-bottom: 20px;
}
::v-deep .el-drawer__body {
    padding: 20px;
}
.wl-info {
    width: 100%;
    height: 14px;
    line-height: 14px;
    font-size: 14px;
}
.wl-info-title {
    font-weight: bold;
    margin-right: 10px;
}
.wl-info div {
    display: flex;
    float: left;
}
.column-btn {
    font-size: 12px;
    display: flex;
    float: right;
    color: #3879eb;
    cursor: pointer;
}
.column-btn .table-setting-icon {
    height: 14px;
    width: 14px;
    margin-right: 5px;
}
.bottom-line {
    border-bottom: 1px dashed #e3e4e6;
    padding-bottom: 20px;
}
::v-deep .el-form {
    padding: 5px;
}
.search-row {
    padding-bottom: 20px;
}
.wl-date-item2 {
    width: 370px !important;
}
.margin {
    margin-right: 10px;
}
.right {
    float: right;
}
.table-container-wrapper {
    height: calc(100% - 63px - 30px);
}
.table-container-wrapper .th {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.underline-content {
    text-decoration: underline;
    color: #3879eb;
    padding: 5px;
    border-radius: 7px;
    cursor: pointer;
}
.waring {
    background-color: #f2b000;
    color: white;
}
.el-icon-download {
    color: #3879eb;
}
.file-table-name-canDownload:hover {
    text-decoration: underline;
    cursor: pointer;
    color: rgb(120, 120, 195);
}
.th-label {
    width: 50%;
    text-align: right;
}
.th-sort i {
    display: flex;
}
.th-sort-up,
.th-sort-down {
    font-size: 16px;
    color: #ccced2;
    cursor: pointer;
    margin-left: 5px;
}
.th-sort-up {
    margin-bottom: -3px;
}
.th-sort-down {
    margin-top: -3px;
}
.th-sort-active {
    color: #3879eb;
}
.text-input {
    position: relative;
}
.text-input .clear-btn {
    position: absolute;
    bottom: 5px;
    right: 5px;
    z-index: 2;
    cursor: pointer;
    color: #ccc;
}
.text-input .clear-btn:hover {
    color: #878d99;
}
.header-btn-position {
    text-align: right;
    margin-top: 10px;
}
.updateGuide {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000;
    z-index: 2001;
}
.updateGuideTitle {
    z-index: 2003;
    border: 2px solid #3879eb !important;
    border-radius: 10px;
}
.updateGuideBtn {
    z-index: 2003;
    border: 2px solid #3879eb !important;
    border-radius: 5px;
    height: 50px;
}
.updateGuideTip {
    z-index: 2003;
    background-color: #3879eb;
    padding: 20px;
    color: white;
    position: absolute;
    right: 280px;
    top: 40px;
    width: 240px;
    border-radius: 10px;
    text-align: left;
    font-size: 14px;
    line-height: normal;
}
.margin-bottom-10 {
    margin-bottom: 10px;
}
.guide-btn {
    float: right;
    color: #3879eb;
}
</style>
<style>
.date-search-popper {
    width: 900px !important;
}
.date-search-popper .el-picker-panel__sidebar {
    width: 130px !important;
}
.date-search-popper .el-picker-panel__body {
    margin-left: 130px !important;
}
</style>
